import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GooglemapsComponent } from './googlemaps.component';
import { GooglemapsRoutingModule } from './googlemaps.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GooglemapsRoutingModule,
  ],
  exports: [
    GooglemapsComponent
  ],
  declarations: [
    GooglemapsComponent
  ],
})
export class GooglemapsModule { }
